var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixPingNotificationsV1PublicNotification from '@wix/ambassador-ping-notifications-v1-public-notification/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var Role;
(function (Role) {
    /** All site contributors. */
    Role["All_Contributors"] = "All_Contributors";
    /** Site owner only. */
    Role["Owner"] = "Owner";
})(Role || (Role = {}));
export var Channel;
(function (Channel) {
    /** No default channel. */
    Channel["Undefined"] = "Undefined";
    /** Site dashboard. */
    Channel["Dashboard"] = "Dashboard";
    /** [Wix Owner](https://www.wix.com/mobile/wix-app) mobile app. */
    Channel["Mobile"] = "Mobile";
    /** Active browser. Supported on Chrome and Safari only. */
    Channel["Browser"] = "Browser";
})(Channel || (Channel = {}));
export var DashboardPages;
(function (DashboardPages) {
    DashboardPages["Undefined_Page"] = "Undefined_Page";
    /** Site dashboard home. */
    DashboardPages["Home"] = "Home";
})(DashboardPages || (DashboardPages = {}));
const _empty = {};
const _publicNotifyRequest = {};
/**
 * Sends a notification.
 *
 *
 * The `notify()` function sends a [notification](https://support.wix.com/en/article/about-your-dashboard-notifications) to the specified recipients on the specified channels.
 *
 * List the the channels for the notification in the `channels` parameter .
 *
 * List the recipients for the notification in the `toContacts`, `toSiteContributors`, and `toTopicsSubscribers` parameters.
 * @public
 * @documentationMaturity preview
 * @requiredField body
 * @requiredField channels
 * @param options - Notification options.
 * @param body - Body of the notification. This contains the main content of the notification.
 * @param channels - Channel through which users receive the notification.
 * - `"Mobile"`: Sends the notification to the Wix App.
 * - `"Dashboard"`: Sends the notification to the collaborator's Wix Dashboard.
 * - `"Browser"`: Sends the notification to the collaborator's browser.
 * @adminMethod
 * @returns Fulfilled when the send notification request is received.
 */
export function notify(body, channels, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            body: '$[0]',
            channels: '$[1]',
            toSiteContributors: '$[2].toSiteContributors',
            toContacts: '$[2].toContacts',
            toTopicsSubscribers: '$[2].toTopicsSubscribers',
            title: '$[2].title',
            action: '$[2].action',
            targetUrl: '$[2].targetUrl',
            targetDashboardPage: '$[2].targetDashboardPage',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _publicNotifyRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _empty,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([body, channels, options]);
        const reqOpts = ambassadorWixPingNotificationsV1PublicNotification.notify(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'body',
                'channels',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=ping-notifications-v1-public-notification.universal.js.map